// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-sheets-container {
    max-width: 100%;
    margin: 0 auto;
    text-align: left;
    padding: 0px 16px;
    margin-bottom: 20px;
}

.sheets-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    flex-wrap: wrap;
    gap: 24px;

}

.custom-report-tile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(36, 99, 235, 0.04);
    border-left-width: 8px;
    border-left-style: solid;
    margin-bottom: 0;
    border-left: 8px solid #fb000087
}

.custom-report-tile:hover {
    background: #f5f8ff;
    box-shadow: 0 4px 18px rgba(37, 99, 235, 0.14);
    cursor: pointer;
}

.sheet-label {
    flex: 1 1;
    font-size: 15px;
    color: #000;
    font-weight: 700;
    text-align: left;
}

@media (max-width: 900px) {
    .sheets-list {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .sheets-list {
        grid-template-columns: 1fr;
    }
}



.download-btn {
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
    font-size: 20px;
    margin-right: 4px;
}

.download-btn:hover {
    background: #1d4ed8;
}

.sheet-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
    min-width: 260px;
    max-width: 340px;
    margin: 0 auto;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 4px;
    display: block;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 1rem;
}

.submit-btn {
    background: #2563eb;
    color: #fff;
    border: none;
    padding: 10px 0;
    border-radius: 8px;
    font-size: 1rem;
    cursor: pointer;
    margin-top: 10px;
    transition: background 0.2s;
}

.submit-btn:hover {
    background: #1d4ed8;
}`, "",{"version":3,"sources":["webpack://./src/pages/ReportsInsights/DownloadSheets.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8CAA8C;IAC9C,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;;;AAIA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".download-sheets-container {\n    max-width: 100%;\n    margin: 0 auto;\n    text-align: left;\n    padding: 0px 16px;\n    margin-bottom: 20px;\n}\n\n.sheets-list {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    flex-wrap: wrap;\n    gap: 24px;\n\n}\n\n.custom-report-tile {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-radius: 10px;\n    background: #fff;\n    box-shadow: 0 2px 10px rgba(36, 99, 235, 0.04);\n    border-left-width: 8px;\n    border-left-style: solid;\n    margin-bottom: 0;\n    border-left: 8px solid #fb000087\n}\n\n.custom-report-tile:hover {\n    background: #f5f8ff;\n    box-shadow: 0 4px 18px rgba(37, 99, 235, 0.14);\n    cursor: pointer;\n}\n\n.sheet-label {\n    flex: 1;\n    font-size: 15px;\n    color: #000;\n    font-weight: 700;\n    text-align: left;\n}\n\n@media (max-width: 900px) {\n    .sheets-list {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 600px) {\n    .sheets-list {\n        grid-template-columns: 1fr;\n    }\n}\n\n\n\n.download-btn {\n    background: #2563eb;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 38px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 0.2s;\n    font-size: 20px;\n    margin-right: 4px;\n}\n\n.download-btn:hover {\n    background: #1d4ed8;\n}\n\n.sheet-form {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    min-width: 260px;\n    max-width: 340px;\n    margin: 0 auto;\n}\n\n.form-group label {\n    font-weight: 500;\n    margin-bottom: 4px;\n    display: block;\n}\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 1rem;\n}\n\n.submit-btn {\n    background: #2563eb;\n    color: #fff;\n    border: none;\n    padding: 10px 0;\n    border-radius: 8px;\n    font-size: 1rem;\n    cursor: pointer;\n    margin-top: 10px;\n    transition: background 0.2s;\n}\n\n.submit-btn:hover {\n    background: #1d4ed8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
